<owl-carousel-child *ngIf="show" #owl [ngClass]="carouselClasses" [options]="options"><ng-content></ng-content></owl-carousel-child>